import { 
  LayoutDashboard, 
  Briefcase, 
  Users, 
  FileText,
  BarChart,
  Brain,
  Shield,
  Activity,
  GraduationCap,
  Bot,
  List,
  Plus,
  CalendarCheck,
  Presentation,
  Bell,
  Sun
} from "lucide-react";
import { MenuCategory } from './types';

// Menu keys map to i18n sidebar.* keys
export const menuCategories: MenuCategory[] = [
  {
    nameKey: 'sidebar.dashboard',
    name: 'Dashboard', 
    icon: LayoutDashboard,
    items: [
      { nameKey: 'sidebar.overview', name: 'Vista general', path: '/dashboard', icon: LayoutDashboard },
      { name: 'Mi Día', path: '/my-day', icon: Sun },
      { nameKey: 'sidebar.executiveReport', name: 'Reporte Ejecutivo', path: '/executive-report', icon: BarChart },
      { name: 'Owner Dashboard', path: '/owner-executive', icon: Shield }
    ]
  },
  {
    nameKey: 'sidebar.projectManagement',
    name: 'Gestión de Proyectos', 
    icon: Briefcase,
    items: [
      { nameKey: 'sidebar.projectDetails', name: 'Detalle Proyectos', path: '/projects', icon: List },
      { nameKey: 'sidebar.autoPlanner', name: 'Planificador Automático con IA', path: '/project-planner', icon: Brain },
      { nameKey: 'sidebar.bulkImport', name: 'Precarga Proyectos', path: '/bulk-import', icon: Plus }
    ]
  },
  {
    nameKey: 'sidebar.taskTrack',
    name: 'TRACK Tareas', 
    icon: CalendarCheck,
    items: [
      { nameKey: 'sidebar.taskManagement', name: 'Gestión de tareas', path: '/task-track', icon: CalendarCheck },
      { nameKey: 'sidebar.activitySummary', name: 'Resumen de Actividad', path: '/task-track/activity-summary', icon: Activity }
    ]
  },
  {
    nameKey: 'sidebar.communication',
    name: 'Comunicación', 
    icon: Activity,
    items: [
      { nameKey: 'sidebar.executiveSummaries', name: 'Resúmenes Ejecutivos', path: '/communication', icon: FileText },
      { nameKey: 'sidebar.createPresentation', name: 'Crear Presentación', path: '/create-presentation', icon: Presentation },
      { nameKey: 'sidebar.alerts', name: 'Alertas', path: '/alerts', icon: Bell }
    ]
  },
  {
    nameKey: 'sidebar.virtualAssistant',
    name: 'Asistente Virtual', 
    icon: Bot,
    items: [
      { nameKey: 'sidebar.chatAndAnalysis', name: 'Chat y análisis', path: '/virtual-agent', icon: Bot }
    ]
  },
  {
    nameKey: 'sidebar.userManual',
    name: 'Manual de Usuario',
    icon: FileText,
    items: [
      { nameKey: 'sidebar.completeGuide', name: 'Guía completa', path: '/user-manual', icon: FileText }
    ]
  },
  {
    nameKey: 'sidebar.projectMembers',
    name: 'Miembros de Proyectos', 
    icon: Users,
    items: [
      { nameKey: 'sidebar.manageMembers', name: 'Gestionar miembros', path: '/project-members', icon: Users }
    ]
  },
  {
    nameKey: 'sidebar.administration',
    name: 'Administración', 
    icon: Shield,
    items: [
      { nameKey: 'sidebar.userManagement', name: 'Gestión de usuarios', path: '/admin/users', icon: Users },
      { nameKey: 'sidebar.logsAndMonitoring', name: 'Logs y monitoreo', path: '/admin/logs', icon: Activity }
    ]
  }
];
